import { render, staticRenderFns } from "./LayoutDefault.vue?vue&type=template&id=8188c770&scoped=true&"
import script from "./LayoutDefault.vue?vue&type=script&lang=js&"
export * from "./LayoutDefault.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8188c770",
  null
  
)

export default component.exports